<template>
  <el-dialog :title="formTitle" :visible.sync="visible" width="500px" @close="bandleClose">
    <el-form :model="form" ref="form" status-icon :rules="rules" label-width="80px" :inline="false">
      <el-form-item label="学号" prop="userName">
        <el-input v-model="form.userName" :readonly="isUpdate"></el-input>
      </el-form-item>
      <!-- <el-form-item label="密码" prop="userPass">
        <el-input v-model="form.userPass"></el-input>
      </el-form-item> -->
      <el-form-item label="姓名" prop="userRealName">
        <el-input v-model="form.userRealName"></el-input>
      </el-form-item>
      <el-form-item label="学院" prop="userCollege">
        <!-- <el-input v-model="form.userCollege"></el-input> -->
        <el-select v-model="form.userCollege" placeholder="请选择院系" clearable>
            <el-option v-for="item in collegeOptions" :key="item.collegeId" :label="item.collegeName"
              :value="item.collegeName" :disabled="item.status == 1"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="角色" prop="roleCode">
        <el-select v-model="form.roleCode" placeholder="">
          <el-option v-for="item in roleOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="bandleSubmit">确 定</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addUserCreate, updateUser } from '@/api/admin.js';
import { getUser } from "../../utils/auth";


export default {
  data() {
    return {
      visible: false,
      form: {
        userName: '',
        userPass: '',
        userRealName: '',
        userCollege: '',
        roleCode: 'ordinary'
      },
      rules: {
        userName: [{ required: true, message: '请输入学号', trigger: 'blur' }],
        // userPass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        userRealName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        userCollege: [{ required: true, message: '请输入学院', trigger: 'blur' }],
        roleCode: [{ required: true, message: '请分配角色', trigger: 'blur' }]
      },
      isUpdate: true,
      options: [{
        value: 'ordinary',
        label: '普通用户'
      }, {
        value: 'admin',
        label: '院级管理员'
      }, {
        value: 'root',
        label: '校级管理员'
      }],
      collegeOptions: [{
        collegeId: '0',
        collegeName: '研究生院'
      }, {
        collegeId: '1',
        collegeName: '航空学院'
      },
      {
        collegeId: '2',
        collegeName: '能源与动力学院'
      },
      {
        collegeId: '3',
        collegeName: '自动化学院'
      },
      {
        collegeId: '4',
        collegeName: '电子信息工程学院/集成电路学院'
      },
      {
        collegeId: '5',
        collegeName: '机电学院'
      },
      {
        collegeId: '6',
        collegeName: '材料科学与技术学院'
      },
      {
        collegeId: '7',
        collegeName: '民航学院'
      },
      {
        collegeId: '8',
        collegeName: '数学学院'
      },
      {
        collegeId: '9',
        collegeName: '经济与管理学院'
      },
      {
        collegeId: '10',
        collegeName: '人文与社会科学学院'
      },
      {
        collegeId: '11',
        collegeName: '艺术学院'
      },
      {
        collegeId: '12',
        collegeName: '外国语学院'
      },
      {
        collegeId: '15',
        collegeName: '航天学院'
      },
      {
        collegeId: '16',
        collegeName: '计算机科学与技术学院/人工智能学院/软件学院'
      },
      {
        collegeId: '17',
        collegeName: '马克思主义学院'
      },
      {
        collegeId: '20',
        collegeName: '通用航空与飞行学院'
      },
      {
        collegeId: '21',
        collegeName: '物理学院'
      }],
      formTitle: '新增用户',
      user: getUser()
    };
  },
  computed: {
    roleOptions() {
      console.log(this.user.roleCode)
      if (this.user.roleCode === 'admin') {
        // 如果用户角色为 "院级管理员"，则不包含 "校级管理员" 选项
        return this.options.filter(role => role.value !== 'root')
      } else {
        return this.options
      }
    }
  },
  methods: {
    openModal(visible, data) {
      this.visible = visible;
      this.isUpdate = data.isUpdate;
      if(!this.isUpdate){
        this.formTitle = '新增用户'
      }
      if (this.isUpdate) {
        this.form = data.row;
        this.formTitle = '编辑用户'
      }
    },
    bandleSubmit() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          if (!this.isUpdate) {
            const res = await addUserCreate(this.form);
            if (res.code == 0) {
              this.visible = false;
              this.$emit('success');
            }
          } else {
            const res = await updateUser(this.form);
            if (res.code == 0) {
              this.visible = false;
              this.$emit('success');
            }
          }
        }
      });
    },
    bandleClose() {
      this.$refs['form'].resetFields();
    },
  },
};
</script>
